import {fetchSettingsSuccess} from "modules/actions";
import Api from "modules/utils/Api";
import {put} from "typed-redux-saga";
import {call} from "typed-redux-saga/macro";

export const fetchSettingSaga = function* () {
	const result = yield* call(Api.Jsons.settings);
	if (result.data) {
		yield* put(fetchSettingsSuccess(result.data));
	}
};
